module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_08.d7dcca4c.svg";